module.exports = __webpack_public_path__ + "static/icons-cursor-0a8fa8e6909c7b063a7015590a8bdc9f.svg";